import data from "./constants.json";

const loadData = () => {
	return data;
};
export default loadData;
